import React from 'react'
import {
  Create,
  SimpleForm,
  TextInput,
  useTranslate,
  BooleanInput,
  useNotify,
  useRedirect,
  required,
} from 'react-admin'
import { Grid } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'
import { isJsonValidate } from 'src/helper/validatorJson'
import { NumberInput } from 'src/components/uiElements/fields/NumberInput'

export const ApplicationCreate = (props) => {
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()

  const onSuccess = () => {
    notify('ra.notification.created_success_femenine', {
      type: 'success',
      messageArgs: { element: translate('ra.single_entity.application') }
    })
    redirect('/application')
  }

  const onError = () => {
    notify('ra.notification.created_error_femenine', {
      type: 'error',
      messageArgs: { element: translate('ra.single_entity.application') }
    })
  }

  return (
    <Create {...props} mutationOptions={{ onSuccess, onError }} actions={null}>
      <CardCommon title={translate('ra.title.create_application')}>
        <SimpleForm toolbar={<CardCrudBottomButtons btnSave={true} />}>
          <Grid container spacing={3}>
            <EditInputsWrap label={translate('ra.field.short_name')} required>
              <TextInput source='short_name' label='' fullWidth validate={[required()]} />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.long_name')}>
              <TextInput source='long_name' label='' fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.expiration')} required>
              <NumberInput source='expiration' label='' defaultValue={0} fullWidth validate={[required()]} noDecimal />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.config')}>
              <TextInput
                source='config'
                label=''
                fullWidth
                validate={isJsonValidate}
                format={(v) => {
                  return JSON.stringify(v ? v : undefined)
                }}
                parse={(v) => {
                  try {
                    if (v.length >= 2) {
                      return JSON.parse(v)
                    }
                  } catch (e) {
                    notify('ra.field.invalid_json', { type: 'error' })
                    return undefined
                  }
                }}
              />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.is_active')}>
              <BooleanInput source='is_active' label={translate('ra.field.is_active')} fullWidth />
            </EditInputsWrap>
          </Grid>
        </SimpleForm>
      </CardCommon>
    </Create>
  )
}
